var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-modal-open": _vm.isModalOpen },
      attrs: { "data-component": "layout-switcher-workspace" },
    },
    [
      _c("div", { staticClass: "header-top-left" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("HITL.agent-ui.layout-picker.active-layout")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-top-right" },
        [
          _c("div", { staticClass: "header-top-label" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("HITL.agent-ui.layout-picker.other-layouts")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "or-button",
            {
              attrs: {
                variant: _vm.ButtonVariant.Text,
                "data-button": "layout-switcher-create-layout",
              },
              on: {
                click: function ($event) {
                  return _vm.toggleCreateModalOpen(true)
                },
              },
            },
            [
              _c("or-icon", { attrs: { icon: "add" } }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("HITL.agent-ui.layout-picker.create-new-layout")
                  ) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-left" },
        [
          _c("layout-switcher-card", {
            attrs: {
              layout: _vm.defaultLayout,
              "default-layout": _vm.getDefaultLayout(_vm.defaultLayout.key),
              "show-warning": _vm.showWarning(_vm.defaultLayout.key),
              "is-active": true,
            },
            on: {
              bookmark: function ($event) {
                return _vm.$emit("layout-bookmark", {
                  key: _vm.defaultLayout.key,
                })
              },
              reset: function ($event) {
                return _vm.$emit("layout-reset", { key: _vm.defaultLayout.key })
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isListEmpty
        ? _c(
            "div",
            { staticClass: "content-right-empty" },
            [
              _c("img", {
                staticClass: "empty-layouts-image",
                attrs: { src: _vm.emptyContentImageSrc },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "empty-layouts-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("HITL.agent-ui.layout-picker.empty-layouts-title")
                    ) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("or-label", { staticClass: "empty-layouts-description" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "HITL.agent-ui.layout-picker.empty-layouts-description"
                      )
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isListEmpty
        ? _c(
            "div",
            { staticClass: "content-right" },
            _vm._l(_vm.listItems, function (item) {
              return _c("layout-switcher-card", {
                key: item.key,
                attrs: {
                  layout: item,
                  "default-layout": _vm.getDefaultLayout(item.key),
                  "show-warning": _vm.showWarning(item.key),
                },
                on: {
                  select: function ($event) {
                    return _vm.$emit("layout-select", { key: item.key })
                  },
                  bookmark: function ($event) {
                    return _vm.$emit("layout-bookmark", { key: item.key })
                  },
                  reset: function ($event) {
                    return _vm.$emit("layout-reset", { key: item.key })
                  },
                  delete: function ($event) {
                    return _vm.$emit("layout-delete", { key: item.key })
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreateModalOpen
        ? _c("base-create-layout-popup", {
            attrs: {
              "is-open": _vm.isCreateModalOpen,
              components: _vm.components,
              "is-agent-app": true,
            },
            on: {
              cancel: function ($event) {
                return _vm.toggleCreateModalOpen(false)
              },
              create: _vm.onCreateLayout,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }